import { render, staticRenderFns } from "./CarEdit.vue?vue&type=template&id=585a9f08"
import script from "./CarEdit.vue?vue&type=script&lang=ts"
export * from "./CarEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585a9f08')) {
      api.createRecord('585a9f08', component.options)
    } else {
      api.reload('585a9f08', component.options)
    }
    module.hot.accept("./CarEdit.vue?vue&type=template&id=585a9f08", function () {
      api.rerender('585a9f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cars/CarEdit.vue"
export default component.exports